var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Box from "onnit-ui/lib/box/Box";
import React from "react";
import { makePseudoButtonProps } from "onnit-ui/lib/utils/PropUtils";
var FlashBanner = function (_a) {
    var headline = _a.headline, url = _a.url, image = _a.image, children = _a.children, button = _a.button, rest = __rest(_a, ["headline", "url", "image", "children", "button"]);
    var buttonProps = url
        ? makePseudoButtonProps(function () {
            if (url) {
                window.location.href = url;
            }
        })
        : {};
    return (React.createElement(Box, __assign({}, rest, buttonProps),
        React.createElement(Box, { display: "grid", width: "100%", maxWidth: ["100%", "100%", "100%", "1200px"], mx: "auto", gridTemplateRows: ["1fr 1fr", "1fr 1fr", "1fr"], gridTemplateColumns: [
                "max-content 1fr min-content",
                "max-content 1fr min-content",
                "1fr max-content 1fr max-content",
                "1fr max-content 1fr 1fr",
            ] },
            React.createElement(Box, { py: [1, 1, 4], px: [2, 2, 6], gridColumn: [2, 2, 1], gridRow: 1, display: "flex", alignItems: "center" }, headline),
            image && (React.createElement(Box, { maxWidth: "100px", p: [2, 2, 4], gridColumn: [1, 1, 2], gridRow: ["1 / span 2", "1 / span 2", "1"] }, image)),
            React.createElement(Box, { p: [2, 2, 4], gridColumn: ["2 / span 2", "2 / span 2", 3], gridRow: [2, 2, 1], display: ["block", "block", "flex"], justifyContent: "center", flexDirection: "column" }, children),
            React.createElement(Box, { p: [2, 2, 6], gridColumn: [3, 3, 4], gridRow: 1, display: "flex", alignItems: "center", justifyContent: ["center", "center", "flex-end"] }, button))));
};
export default FlashBanner;
//# sourceMappingURL=FlashBanner.js.map